<template>
  <router-view
    @mousemove="onUserInputHandle()"
    @keydown="onUserInputHandle()"
    @mousedown="onUserInputHandle()"
  />
</template>
<script>
import { callApi } from '@/api/http'
import usePermission from '@/composables/usePermission'
import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
export default {
  setup() {
    const route = useRoute()
    const router = useRouter()
    const { update_session_last } = usePermission()
    let lastCallSessionApiTimer = new Date().getTime()
    const onUserInputHandle = async () => {
      if (route.path === '/sign') return
      const now = new Date().getTime()
      const limit_time = now - lastCallSessionApiTimer
      if (limit_time > 10000) {
        lastCallSessionApiTimer = new Date().getTime()
        console.log('update')
        await update_session_last()
      }
    }
    watch(
      ()=>router,
      ()=>{
        var userAgentInfo = navigator.userAgent;
        var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) { 
              console.log('usepc');
              router.push('/usepc')
              break;
            }
        }
      },
      { immediate: true, deep: true }
    )

    setInterval(() => {
      callApi(
        'post',
        'user/info',
        {},
        {
          disableLoading: true,
        },
      )
    }, 600000)
    return {
      onUserInputHandle,
    }
  },
}
</script>
<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
body {
  overflow: auto !important;
}
</style>
